import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PrivyProvider,} from '@privy-io/react-auth';
import { WagmiProvider } from '@privy-io/wagmi';
import { wagmiConfig } from '../connectors/wagmiConfig';
import xBullRunLogo from '../assets/x-bull-run.png';
import { arbitrum, avalanche, base, bsc, polygon } from 'viem/chains';

const queryClient = new QueryClient();

export const Providers = ({ children }) => {
  const privyConfig = {
    embeddedWallets: {
      createOnLogin: 'users-without-wallets',
      requireUserPasswordOnCreate: false,
    },
    loginMethods: ['email', 'google', 'wallet'],
    appearance: {
      showWalletLoginFirst: false,
      theme: 'light',
      logo: xBullRunLogo,
    },
    defaultChain: polygon,
    supportedChains: [arbitrum, avalanche, base, bsc, polygon],
  };

  return (
    <PrivyProvider
      appId={process.env.REACT_APP_PRIVY_APP_ID || ''}
      config={privyConfig}
    >
      <QueryClientProvider client={queryClient}>
        <WagmiProvider config={wagmiConfig} reconnectOnMount={false}>
          {children}
        </WagmiProvider>
      </QueryClientProvider>
    </PrivyProvider>
  );
};
